const reelsContainer = document.querySelector(".video_reels");
const buttonPlay = reelsContainer.querySelectorAll("button");
const modalContainer = document.querySelector("#modal__video-reels-container");
const btnClose = document.querySelector("#modal__video-reels-btn-close");
const modalVideo = document.querySelector("#modal__video-reels");

buttonPlay.forEach((button) => {
  button.addEventListener("click", (evt) => {
    evt.preventDefault();
    const target = evt.target;
    const urlVideo = target.dataset.url;
    modalVideo.src = urlVideo;
    modalContainer.style.display = "flex";
    modalContainer.style.zIndex = "2000";
    modalContainer.style.opacity = "1";
  });
});

btnClose.onclick = function (event) {
  if (event.target == btnClose) {
    modalContainer.style.display = "none";
    modalVideo.pause();
  }
};

window.onclick = function (event) {
  if (event.target == modalContainer || event.target == btnClose) {
    modalContainer.style.display = "none";
    modalVideo.pause();
  }
};
